/**
 * Einfaches Glob-Matching für Scope-Allowlisten (Umbau A2).
 * `*` = ein Pfadsegment, `**` = beliebig viele Segmente.
 */

export function pfadPasstZuGlob(pfad: string, glob: string): boolean {
  const normPfad = normalisierePfad(pfad);
  const normGlob = normalisierePfad(glob);
  if (normGlob === "/**") return true;
  return matchSegmente(normPfad.split("/").filter(Boolean), normGlob.split("/").filter(Boolean));
}

export function pfadInAllowlist(pfad: string, globs: string[]): boolean {
  return globs.some((g) => pfadPasstZuGlob(pfad, g));
}

function normalisierePfad(p: string): string {
  if (!p) return "/";
  const withSlash = p.startsWith("/") ? p : `/${p}`;
  return withSlash.replace(/\/+/g, "/");
}

function matchSegmente(pfadSeg: string[], globSeg: string[]): boolean {
  let i = 0;
  let j = 0;
  while (i < pfadSeg.length && j < globSeg.length) {
    const g = globSeg[j]!;
    if (g === "**") {
      if (j === globSeg.length - 1) return true;
      for (let k = i; k <= pfadSeg.length; k += 1) {
        if (matchSegmente(pfadSeg.slice(k), globSeg.slice(j + 1))) return true;
      }
      return false;
    }
    if (g === "*") {
      i += 1;
      j += 1;
      continue;
    }
    if (g !== pfadSeg[i]) return false;
    i += 1;
    j += 1;
  }
  while (j < globSeg.length && globSeg[j] === "**") j += 1;
  return i === pfadSeg.length && j === globSeg.length;
}
